import { useTheme } from "../../context/ThemeContext";

export function ThemedShell({ children }) {
  const { theme } = useTheme();
  const c = theme.colors;
  const style = {
    "--t-surface": c.surface, "--t-surface2": c.surface2, "--t-border": c.border,
    "--t-primary": c.primary, "--t-accent": c.accent, "--t-success": c.success,
    "--t-text": c.text, "--t-muted": c.muted, "--t-on-primary": c.onPrimary, "--t-on-accent": c.onAccent,
    "--t-font-heading": theme.fonts.heading, "--t-font-body": theme.fonts.body,
    fontFamily: "var(--t-font-body)", color: "var(--t-text)",
  };
  return (
    <div style={style} className={`min-h-screen ${theme.bgClass}`} data-theme={theme.id} data-testid="themed-shell">
      {children}
    </div>
  );
}

export function ThemedCard({ children, className = "", ...rest }) {
  return (
    <div className={`rounded-3xl border-2 ${className}`} style={{ background: "var(--t-surface)", borderColor: "var(--t-border)" }} {...rest}>
      {children}
    </div>
  );
}

export function ThemedProgress({ value, fill = "var(--t-accent)", className = "" }) {
  return (
    <div className={`h-3.5 rounded-full overflow-hidden ${className}`} style={{ background: "var(--t-surface2)" }}>
      <div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.max(0, Math.min(100, value))}%`, background: fill }} />
    </div>
  );
}
